define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/heading/StringSelection",
	"csi/def/Relationship",
	"csi/reflection",
	"csi/xml",
	"csi/xml/Query"
], function(declare, lang, StringSelection, Relationship, reflection, xml, Query) {

	return declare(StringSelection, {
		getStore: function(/*Context*/ctx, /*Heading*/h, /*Any*/value, /*Boolean*/bAll) {
			// summary: return a store of validation-rule groups of associated business object
			var bo = this._getBusinessObject(ctx);
			if (bo) {
				h.m_relationship = lang.mixin(new Relationship(), {
					m_url: bo,
					m_id: "ValidationRuleGroups",
					m_query: new Query()
						.Attr("Node Name", xml.OP_NOT_EQUALS, "")
						.Attr("AppliedOn", xml.OP_NOT_EQUALS, "0")
				});
			}
			return this.inherited(arguments);
		},

		_getBusinessObject: function(ctx) {
			var parent = ctx.getNodeParent();
			var bo = this._getBusinessObjectByNodeName(parent);
			if (bo)
				return bo;

			var grandparent = ctx.cache.getNode(parent.__Parent__, true);
			return this._getBusinessObjectByNodeName(grandparent);
		},

		_getBusinessObjectByNodeName: function(node) {
			var boClassName = node.$Name;
			if (!boClassName)
				return null;

			var rc = reflection.getClass(boClassName);
			if (!rc)
				return null;

			return rc.getBusinessObject();
		}
	});
});